var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "geel_logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 1089.6758,
    viewBox: "0 0 1000 1089.6758",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2989"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath2999"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 86.555,267.144 503.189,0 0,383.056 -503.189,0 0,-383.056 z",
    id: "path3001"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3151"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 676.299,0 0,922.913 L 0,922.913 0,0 z",
    id: "path3153"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2993",
    transform: "matrix(1.25,0,0,-1.25,-244.07611,1515.4567)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2995",
    transform: "matrix(2.8169808,0,0,2.8169808,-355.51211,-619.63553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2997",
    clipPath: "url(#clipPath2999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3075",
    transform: "translate(296.6335,380.7189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -19.376,0 0,11.787 c 0,3.427 -0.209,5.569 -0.624,6.413 -0.413,0.855 -1.322,1.281 -2.734,1.281 -1.593,0 -2.607,-0.521 -3.036,-1.554 -0.428,-1.034 -0.643,-3.266 -0.643,-6.698 l 0,-31.513 c 0,-3.294 0.215,-5.447 0.643,-6.45 0.429,-1.012 1.398,-1.511 2.9,-1.511 1.443,0 2.381,0.503 2.827,1.517 0.443,1.006 0.667,3.372 0.667,7.096 l 0,8.538 19.376,0 0,-2.646 c 0,-7.016 -0.545,-11.991 -1.634,-14.93 -1.087,-2.932 -3.496,-5.5 -7.229,-7.711 -3.723,-2.209 -8.319,-3.307 -13.776,-3.307 -5.675,0 -10.356,0.928 -14.039,2.801 -3.679,1.866 -6.116,4.459 -7.32,7.759 -1.197,3.311 -1.795,8.284 -1.795,14.93 l 0,19.8 c 0,4.882 0.185,8.542 0.555,10.988 0.366,2.443 1.466,4.792 3.29,7.053 1.823,2.262 4.359,4.038 7.595,5.337 3.238,1.296 6.954,1.948 11.162,1.948 5.699,0 10.41,-1.008 14.125,-3.014 3.71,-2.002 6.151,-4.502 7.316,-7.499 C -0.581,17.421 0,12.764 0,6.441 L 0,0 z",
    style: {
      fill: "#0c2950",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path3077"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3079",
    transform: "translate(325.8998,366.6497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -0.962,7.668 -1.94,17.154 -2.937,28.456 -4.891,15.477 -6.125,5.991 -6.631,0 L 0,0 z m 10.25,43.557 11.117,-67.738 -19.81,0 -1.042,12.187 -6.937,0 -1.113,-12.187 -20.086,0 9.851,67.738 28.02,0 z",
    style: {
      fill: "#0c2950",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path3081"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3083",
    transform: "translate(383.6181,410.207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 0,-14.913 -11.544,0 0,-52.827 -19.382,0 0,52.827 -11.449,0 0,14.913 L 0,0 z",
    style: {
      fill: "#0c2950",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path3085"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3087",
    transform: "translate(423.5783,389.6918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -17.983,0 0,5.046 c 0,2.351 -0.237,3.85 -0.693,4.493 -0.459,0.644 -1.227,0.969 -2.306,0.969 -1.167,0 -2.047,-0.437 -2.65,-1.302 -0.596,-0.868 -0.896,-2.188 -0.896,-3.951 0,-2.271 0.334,-3.976 1.004,-5.126 0.631,-1.15 2.454,-2.527 5.461,-4.14 8.629,-4.646 14.056,-8.458 16.295,-11.447 2.239,-2.983 3.359,-7.804 3.359,-14.447 0,-4.831 -0.627,-8.392 -1.862,-10.678 -1.245,-2.295 -3.647,-4.214 -7.204,-5.759 -3.552,-1.55 -7.703,-2.325 -12.42,-2.325 -5.184,0 -9.603,0.891 -13.268,2.682 -3.662,1.787 -6.064,4.062 -7.199,6.827 -1.134,2.768 -1.701,6.689 -1.701,11.774 l 0,4.439 17.979,0 0,-8.269 c 0,-2.554 0.256,-4.179 0.766,-4.915 0.502,-0.732 1.402,-1.09 2.691,-1.09 1.299,0 2.252,0.461 2.885,1.385 0.627,0.923 0.945,2.29 0.945,4.112 0,3.995 -0.596,6.615 -1.791,7.845 -1.218,1.229 -4.241,3.276 -9.059,6.144 -4.82,2.895 -8.017,4.997 -9.578,6.31 -1.565,1.315 -2.866,3.13 -3.892,5.447 -1.03,2.312 -1.544,5.274 -1.544,8.874 0,5.197 0.73,8.988 2.189,11.388 1.456,2.405 3.811,4.282 7.066,5.637 3.253,1.356 7.178,2.032 11.778,2.032 5.032,0 9.316,-0.739 12.866,-2.22 3.543,-1.481 5.888,-3.345 7.04,-5.595 C -0.573,11.89 0,8.071 0,2.678 L 0,0 z",
    style: {
      fill: "#0c2950",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path3089"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3091",
    transform: "translate(201.5609,565.7573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 16.418,-73.731 67.849,-134.261 135.955,-163.225 68.099,28.964 119.533,89.494 135.953,163.225 -12.431,7.051 -20.821,20.392 -20.821,35.701 0,10.301 3.802,19.711 10.074,26.915 C 222.065,76.738 179.903,84.444 135.94,84.444 91.981,84.444 49.823,76.743 10.73,62.629 17.01,55.423 20.814,46.009 20.814,35.701 20.814,20.392 12.424,7.051 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path3093"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3095",
    transform: "translate(457.5299,601.4581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0,9.75 3.869,18.59 10.142,25.091 8.499,25.714 6.848,26.319 5.193,26.915 -1.079,19.711 -4.883,10.301 -4.883,0 c 0,-15.309 8.392,-28.65 20.821,-35.701 -16.42,-73.731 -67.852,-134.26 -135.951,-163.225 -68.106,28.965 -119.537,89.494 -135.955,163.225 12.424,7.051 20.814,20.392 20.814,35.701 0,10.308 -3.804,19.722 -10.084,26.928 -1.654,-0.599 -3.309,-1.201 -4.952,-1.824 6.284,-6.501 10.153,-15.347 10.153,-25.104 0,-14.878 -8.988,-27.651 -21.832,-33.197 16.205,-79.303 69.946,-144.941 141.856,-177.544 C -48.112,-178.138 5.63,-112.5 21.839,-33.197 8.992,-27.651 0,-14.878 0,0",
    style: {
      fill: "#0c2950",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path3097"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3099",
    transform: "translate(241.2521,581.4747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -1.449,0.997 -3.981,2.25 -3.74,3.059 0.569,1.893 14.106,1.94 16.614,-7.899 2.06,-8.084 4.211,-18.357 8.857,-20.03 4.893,-1.761 7.81,0 9.927,1.466 0,0 7.533,6.332 13.939,6.455 5.641,0.107 9.656,-1.628 14.541,-4.233 0,0 9.41,-5.858 16.026,-5.64 6.62,0.217 10.415,4.015 13.565,6.075 3.143,2.062 11.731,7.315 17.246,4.665 2.713,-1.302 0.543,-5.317 -0.542,-7.268 -0.732,-1.322 -3.606,-7.335 1.304,-9.438 6.681,-2.865 25.06,15.839 40.248,15.839 6.411,0 13.935,-6.455 13.935,-6.455 2.115,-1.466 5.045,-3.255 9.927,-1.466 4.629,1.697 7.107,12.259 8.793,19.772 2.279,10.155 15.679,9.931 15.827,8.138 0.076,-0.874 -1.939,-1.944 -3.436,-2.84 -1.601,-0.96 -1.694,-1.373 1.443,-2.368 7.031,-2.228 13.86,-4.736 20.269,-7.298 -6.368,8.125 -10.177,18.346 -10.177,29.449 0,11.04 3.768,21.21 10.069,29.317 -37.158,12.595 -76.973,19.426 -118.385,19.426 -41.408,0 -81.221,-6.825 -118.371,-19.415 6.306,-8.108 10.076,-18.284 10.076,-29.328 0,-11.072 -3.787,-21.273 -10.127,-29.387 6.493,2.618 13.386,5.141 20.288,7.236 C 1.395,-1.173 1.057,-0.726 0,0",
    style: {
      fill: "#0c2950",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path3101"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3103",
    transform: "translate(369.1871,468.2028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -2.273,-2.618 -10.764,-15.658 -14.517,-20.116 -3.819,-4.528 -9.866,-8.902 -17.182,-8.902 -7.319,0 -13.367,4.374 -17.186,8.902 C -52.637,-15.658 -61.13,-2.618 -63.402,0 -67.946,5.24 -74.857,5.051 -86.87,2.114 -93.992,0.37 -100.827,-1.953 -107.014,-4.394 -86.037,-27.225 -60.431,-45.742 -31.66,-58.407 -2.9,-45.748 22.7,-27.24 43.671,-4.418 37.464,-1.966 30.609,0.364 23.468,2.114 11.455,5.051 4.545,5.24 0,0",
    style: {
      fill: "#0c2950",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path3105"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3107",
    transform: "translate(344.093,503.5463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -2.125,-1.681 -4.607,-3.789 -6.721,-3.789 -2.11,0 -4.592,2.108 -6.719,3.789 -0.777,0.65 -0.633,1.544 1.3,1.841 1.313,0.202 3.036,0.338 5.419,0.338 2.387,0 4.105,-0.134 5.425,-0.336 C 0.631,1.544 0.777,0.65 0,0 m 0.067,-41.324 2.252,-2.282 c 0,0 1.709,2.74 1.791,7.216 0,0 1.903,-3.989 1.408,-7.457 -0.08,-0.571 -0.267,-1.979 -1.682,-2.42 -1.408,-0.441 -4.826,-1.692 -10.359,-1.692 -5.533,0 -8.952,1.251 -10.362,1.692 -1.412,0.441 -1.599,1.849 -1.679,2.42 -0.495,3.468 1.41,7.457 1.41,7.457 0.08,-4.476 1.789,-7.216 1.789,-7.216 l 2.252,2.282 1.978,-2.878 2.605,2.497 2.007,-2.814 2.006,2.814 2.605,-2.497 1.979,2.878 z m 68.6,83.679 c -5.956,1.673 -9.636,2.741 -14.112,3.477 -3.659,0.601 -6.66,-1.621 -7.453,-4.939 -1.151,-4.831 -4.476,-11.901 -13.291,-13.369 -12.558,-2.092 -15.594,8.289 -18.728,7.292 0,0 4.484,4.155 11.479,8.245 -0.424,-1.08 -0.728,-2.286 -0.728,-3.56 0,-4.614 3.875,-8.356 3.875,-8.356 0,0 3.869,3.742 3.869,8.356 0,2.456 -1.096,4.658 -2.123,6.187 7.609,4.161 15.152,5.04 15.152,5.04 0,0 -8.291,4.626 -22.667,-3.053 C 20.039,45.589 15.361,42.967 9.135,37.509 7.658,36.211 2.491,32.26 3.264,26.616 3.711,23.341 7.582,21.064 5.628,18.642 3.916,16.525 0.713,19.854 -6.605,19.854 c -7.322,0 -10.525,-3.329 -12.235,-1.212 -1.954,2.422 1.914,4.699 2.364,7.974 0.773,5.644 -4.394,9.595 -5.871,10.893 -6.226,5.458 -10.904,8.08 -14.805,10.166 -14.377,7.679 -22.667,3.053 -22.667,3.053 0,0 7.543,-0.879 15.149,-5.04 -1.024,-1.529 -2.12,-3.731 -2.12,-6.187 0,-4.614 3.868,-8.356 3.868,-8.356 0,0 3.876,3.742 3.876,8.356 0,1.274 -0.304,2.48 -0.732,3.56 6.996,-4.09 11.483,-8.245 11.483,-8.245 -3.137,0.997 -6.17,-9.384 -18.728,-7.292 -8.816,1.468 -12.14,8.538 -13.291,13.369 -0.793,3.318 -3.794,5.54 -7.458,4.939 -4.478,-0.736 -8.157,-1.804 -14.116,-3.477 -16.736,-4.693 -31.346,-10.473 -42.517,-15.502 5.41,-13.098 12.013,-25.57 19.681,-37.288 3.113,1.449 6.046,2.726 8.453,3.61 7.055,2.597 15.179,6.261 28.447,0.123 14.067,-6.501 25.331,-19.141 25.331,-19.141 0.792,0.497 0.553,2.295 -0.218,3.78 -1.36,2.618 -4.419,5.641 -6.099,7.325 -8.611,8.609 -0.721,9.532 2.394,9.504 5.458,-0.047 11.098,-2.032 11.098,-2.032 -8.417,8.428 -32.958,8.788 -32.958,8.788 17.434,4.771 38.861,-5.496 38.861,-5.496 -17.28,15.365 -55.044,11.681 -55.044,11.681 28.16,7.761 53.693,-5.248 53.693,-5.248 -13.165,11.696 -35.665,12.484 -35.665,12.484 24.179,2.698 41.251,-9.244 46.582,-16.153 4.211,-5.462 5.278,-7.302 5.651,-8.002 0.413,-0.773 2.166,-4.015 0.215,-6.293 -1.952,-2.275 -6.295,-1.845 -6.295,-1.845 0,0 -1.298,-5.317 -0.975,-7.376 0,0 -2.495,1.628 -2.928,7.376 0,0 -3.47,0.543 -6.291,2.278 -2.822,1.733 -7.274,4.555 -9.442,2.493 -2.168,-2.058 0.325,-5.313 1.412,-6.941 1.085,-1.628 14.967,-25.58 17.195,-28.807 2.631,-3.824 7.156,-8.018 14.702,-8.018 7.544,0 12.071,4.194 14.702,8.018 2.226,3.227 16.107,27.179 17.19,28.807 1.088,1.628 3.583,4.883 1.413,6.941 -2.166,2.062 -6.618,-0.76 -9.441,-2.493 -2.82,-1.735 -6.29,-2.278 -6.29,-2.278 -0.433,-5.748 -2.928,-7.376 -2.928,-7.376 0.323,2.059 -0.975,7.376 -0.975,7.376 0,0 -4.343,-0.43 -6.295,1.845 -1.953,2.278 -0.198,5.52 0.215,6.293 0.37,0.7 1.438,2.54 5.651,8.002 5.331,6.909 22.403,18.851 46.579,16.153 0,0 -22.499,-0.788 -35.664,-12.484 0,0 25.537,13.009 53.688,5.248 0,0 -37.759,3.684 -55.038,-11.681 0,0 21.428,10.267 38.853,5.496 0,0 -24.532,-0.36 -32.95,-8.788 0,0 5.641,1.985 11.098,2.032 3.116,0.028 11.006,-0.895 2.394,-9.504 -1.681,-1.684 -4.738,-4.707 -6.099,-7.325 -0.77,-1.485 -1.014,-3.283 -0.217,-3.78 0,0 11.264,12.64 25.324,19.141 13.268,6.138 21.393,2.474 28.448,-0.123 2.422,-0.891 5.375,-2.176 8.517,-3.64 7.666,11.72 14.275,24.189 19.685,37.285 -11.18,5.036 -25.817,10.831 -42.588,15.535",
    style: {
      fill: "#0c2950",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path3109"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3111",
    transform: "translate(263.7507,602.1645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -1.83,-0.467 -4.842,-3.068 -10.241,-4.452 -9.217,-2.36 -15.423,1.091 -17.492,9.169 -2.039,7.955 2.075,14.717 12.224,17.315 3.576,0.915 6.344,0.911 7.927,1.318 0.488,0.123 1.278,0.415 2.331,0.865 l -0.075,-6.801 c -3.18,0.926 -6.317,1.014 -9.242,0.265 -5.886,-1.507 -8.371,-5.666 -6.859,-11.569 1.395,-5.441 4.844,-7.591 10.041,-6.261 4.508,1.154 6.484,3.402 5.733,6.332 l -0.577,2.26 -5.52,-1.414 c -1.182,-0.302 -2.02,-0.741 -2.872,-1.804 l 0.03,3.44 c 0.034,1.882 0.407,2.288 2.435,2.809 l 11.289,2.892 c -0.51,-0.887 -0.338,-1.559 -0.09,-2.521 L 2.032,0.164 C 1.046,0.136 0.364,0.093 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path3113"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3115",
    transform: "translate(270.2894,606.8516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -2.7,16.678 c -0.374,2.304 -1.214,3.567 -2.775,4.015 l 25.819,4.183 c -0.228,-0.433 -0.297,-0.792 -0.247,-1.091 0.082,-0.513 1.027,-2.153 2.42,-5.255 -3.053,1.3 -6.02,1.257 -9.372,0.714 l -9.806,-1.586 0.962,-5.931 10.84,1.756 c 1.447,0.235 2.426,0.743 3.199,1.219 L 16.852,10.784 C 16.465,9.757 15.638,9.1 14.521,8.917 L 5.005,7.378 6.041,0.98 16.385,2.654 c 4.095,0.666 7.193,2.259 9.109,4.584 -0.777,-3.847 -1.406,-6.007 -1.3,-6.646 0.051,-0.34 0.275,-0.657 0.635,-1.038 L -1.363,-4.685 C -0.017,-3.813 0.375,-2.304 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path3117"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3119",
    transform: "translate(299.8354,611.3634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -1.249,16.848 c -0.17,2.327 -0.897,3.66 -2.413,4.243 l 26.084,1.929 c -0.263,-0.411 -0.364,-0.764 -0.342,-1.065 0.036,-0.517 0.837,-2.235 1.959,-5.445 -2.935,1.561 -5.89,1.774 -9.279,1.522 L 4.853,17.302 5.3,11.311 16.25,12.12 c 1.464,0.11 2.484,0.53 3.294,0.939 L 17.722,9.285 C 17.249,8.295 16.366,7.711 15.238,7.625 L 5.623,6.915 6.103,0.452 16.551,1.225 c 4.14,0.306 7.361,1.63 9.473,3.778 -1.109,-3.767 -1.921,-5.862 -1.871,-6.508 0.024,-0.344 0.215,-0.678 0.54,-1.087 L -1.765,-4.549 C -0.351,-3.796 0.172,-2.327 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path3121"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3123",
    transform: "translate(327.5187,634.6779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 10.431,-0.17 C 8.954,-0.794 8.174,-2.293 8.14,-4.538 l -0.273,-16.896 7.082,-0.114 c 3.981,-0.065 7.096,0.706 9.815,2.909 -1.442,-3.65 -2.48,-5.665 -2.493,-6.313 -0.006,-0.344 0.2,-0.695 0.485,-1.13 l -23.174,0.377 c 1.477,0.665 2.127,2.08 2.168,4.37 L 2.022,-4.441 C 2.058,-2.108 1.453,-0.715 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path3125"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3127",
    transform: "translate(372.0717,620.4142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.398,5.343 -2.265,8.575 -7.193,8.941 -5.436,0.405 -8.734,-2.687 -9.171,-8.545 -0.39,-5.257 2.269,-8.489 7.201,-8.855 C -3.772,-8.861 -0.431,-5.774 0,0 m -9.182,-13.225 c -9.318,0.693 -14.204,6.213 -13.606,14.228 0.605,8.144 6.538,13.335 15.608,12.661 C 2.142,12.971 7.079,7.578 6.45,-0.87 5.873,-8.627 -0.11,-13.901 -9.182,-13.225",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path3129"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3131",
    transform: "translate(386.5193,609.8654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.342,-2.353 -0.101,-3.748 1.386,-4.779 l -9.72,1.588 c 1.6,0.44 2.409,1.751 2.792,4.097 l 2.698,16.504 c 0.385,2.345 0.034,3.847 -1.341,4.773 L 7.849,20.215 C 7.636,19.944 7.518,19.742 7.498,19.615 7.472,19.447 7.539,19.083 7.675,18.622 l 6.461,-20.717 2.579,16.306 c 0.383,2.344 -0.082,3.91 -1.425,4.786 l 9.474,-1.548 C 22.659,16.784 22.381,15.341 22.067,13.423 22.058,13.38 22.043,13.296 22.03,13.21 L 18.984,-5.425 c -0.147,-0.896 -0.177,-1.591 0.224,-2.271 L 9.326,-6.08 c 0.261,0.308 0.385,0.551 0.413,0.722 0.028,0.17 -0.051,0.447 -0.189,0.906 L 2.357,16.999 0,0 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path3133"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3135",
    transform: "translate(432.8205,596.6088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -1.828,0.465 -5.718,-0.375 -11.12,1.001 -9.218,2.347 -13.014,8.351 -10.955,16.433 2.025,7.955 8.871,11.918 19.027,9.337 C 0.525,25.86 2.958,24.53 4.54,24.127 5.027,24 5.86,23.877 7.001,23.767 L 3.675,17.836 c -2.349,2.338 -5.059,3.916 -7.983,4.661 -5.89,1.501 -10.062,-0.962 -11.565,-6.865 -1.387,-5.445 0.609,-8.984 5.81,-10.308 4.511,-1.148 7.322,-0.123 8.069,2.807 l 0.575,2.263 -5.524,1.406 c -1.178,0.299 -2.125,0.316 -3.384,-0.209 l 1.672,3.007 c 0.937,1.634 1.458,1.815 3.488,1.294 L 6.127,13.02 C 5.253,12.484 5.083,11.815 4.84,10.852 L 1.864,-0.833 C 0.984,-0.385 0.366,-0.093 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path3137"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeel);
export default __webpack_public_path__ + "static/media/geel.1fc269953d87091cf3262570bfe568ed.svg";
export { ForwardRef as ReactComponent };